/// <amd-module name="VC/Common/Helpers" />

/**
 * Helper namespace for parsing branch names. This assumes that branch names are
 * made up of segments seperated by the '/' character.
 */
export namespace BranchName {
    
    /**
     * This will remove the first two segments of the branch name (refs/heads).
     * 
     * @param branchName The fully qualified branch name.
     *
     * @returns The relative branch name starting from the 3rd segment.
     */
    export function getHeadRelativeName(branchName: string): string {
        return branchName.substring(branchName.indexOf("/", branchName.indexOf("/") + 1) + 1);
    }

    /**
     * Returns the fully qualified parent branch name of supplied branch name.
     * 
     * @param branchName The fully qualified branch name.
     * 
     * @returns The fully qualified parent branch name.
     */
    export function getParentName(branchName: string): string {
        return branchName.substring(0, branchName.lastIndexOf("/"));
    }

    /**
     * Returns the terminal name of the branch, or the last segment.
     * 
     * @param branchName The fully qualified branch name.
     * 
     * @returns Returns the last segment of the branch name.
     */
    export function getShortName(branchName: string): string {
        return branchName.substring(branchName.lastIndexOf("/") + 1);
    }
}
